import React, { useState } from "react";
import WalletConnect from "./components/WalletConnect";
import TokenBalance from "./components/TokenBalance";
import DexSwapForm from "./components/DexSwapForm";
import FeeManager from "./components/FeeManager";
import "./App.css";

function App() {
    const [provider, setProvider] = useState(null);
    const [account, setAccount] = useState("");

    return (
      <div className="App">
      <h1>DEX 프론트엔드</h1>
      <WalletConnect setProvider={setProvider} setAccount={setAccount} />
      <hr />
      {account && (
          <>
              <TokenBalance provider={provider} account={account} />
              <hr />
              <DexSwapForm provider={provider} account={account} />
              <hr />
              <FeeManager provider={provider} account={account} />
          </>
      )}
      </div>
    );
}

export default App;
